<template >
    <div id="tabs-footer">
        <CutawayFloorsFooter
            v-if="data.type ==='cutaway' && !data.activeHotspot" 
            :data="data"
        /> 
        <RoomItemsFooter
            v-if=" data.type ==='configurable-tour'"
            :data="data"
        />
        <SearchRouteFooter
            v-if="data.type ==='map' && showSearchRoute"
            :data="data"
            :showSearchRoute=" showSearchRoute"
            @toggle-search-route="$emit('toggle-search-route')"
        />
    </div>
</template>

<script>
    import CutawayFloorsFooter from '@/layout/alternative/cutaway/components/CutawayFloorsFooter';
    import RoomItemsFooter from '@/layout/alternative/configurableTour/components/RoomsItemsFooter';
    import SearchRouteFooter from '@/layout/alternative/map/components/SearchRouteFooter';

    export default {
        name: "FooterLayout",
        components:{
            CutawayFloorsFooter,
            RoomItemsFooter,
            SearchRouteFooter
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            showSearchRoute: {
                type: Boolean,
                required: true
            }
        },
    };
</script>




// WEBPACK FOOTER //
// src/layout/alternative/layout/FooterLayout.vue